import { actions } from 'react-redux-form'

const ResetPatientForm = () => actions.reset('patient')

export default ResetPatientForm
